import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";
import RoutesMap from "../../../../route_control/RouteControl"

export const itemByLocationTodo = createAsyncThunk('itemByLocation', async (data) => {
    // console.log(data)
    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `item_issue`,
            params: {
                'location_id': data?.locationId,
                'sub_location_id': data?.subLocationId,
                'block_id': data?.blockId,
                'staff_id': data?.staffId,
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'status': data?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const itemByLocationSlice = createSlice({
    name: 'itemByLocation',
    initialState: {
        data: [],
    },
    reducers: {
        removeItems: (state, action) => {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(itemByLocationTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(itemByLocationTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export const { removeItems } = itemByLocationSlice.actions;
export default itemByLocationSlice.reducer; 